import { render, staticRenderFns } from "./BillingPlanTab.vue?vue&type=template&id=556a8796"
import script from "./BillingPlanTab.vue?vue&type=script&lang=js"
export * from "./BillingPlanTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports